var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editableDiv",staticClass:"editable-input",class:{ invalid: _vm.isInvalid },attrs:{"contenteditable":"true","data-placeholder":_vm.placeholder},on:{"input":_vm.onInput,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }